// extracted by mini-css-extract-plugin
export default {"singleQuestionPageContainer":"styles_singleQuestionPageContainer__il4g6","textWrapper":"styles_textWrapper__wnTcf","buttonWrapper":"styles_buttonWrapper__BPWFN"};